export const ad = "gelo-website.firebaseapp.com"